import { AppBar, Menu, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Core";
import { DefaultListParameters } from 'assets/appConfig';
import { GlobalClassKeys, TextColorStyleClasses } from 'assets/jss/common-styles';
import ButtonDropdown from 'components/Buttons/ButtonDropdown';
import ButtonResetFilter from 'components/Buttons/ButtonResetFilter';
import { LoadingIndicator } from 'components/CallServer/LoadingIndicator';
import { RequestErrorReport } from 'components/CallServer/RequestErrorReport';
import { MuiFilterAppBar, MuiFilterLine, MuiFilterToolbar } from 'components/MuiExtras/Filter';
import MuiMessageBox from 'components/MuiExtras/MessageBox/MuiMessageBox';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiMenuItemChecked from 'components/MuiExtras/MuiMenuItemChecked';
import MuiPagination from 'components/MuiExtras/MuiPagination';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import MuiColor, { MuiColors } from 'components/MuiExtras/Typography/MuiColor';
import { RefreshLink } from 'components/RefreshLink';
import { withSnackbar, WithSnackbar } from 'components/SnackbarProvider/Snackbar';
import ApprovalStatusName from 'components/Translations/ApprovalStatusName';
import FileCognitiveAnalysisReasonName from 'components/Translations/FileCognitiveAnalysisReasonName';
import JobLogStatusName from 'components/Translations/JobLogStatusName';
import PublicationCognitiveAnalysisReasonName from 'components/Translations/PublicationCognitiveAnalysisReasonName';
import { Formaters } from 'lib/Formarters';
import { ApprovalStatus, FileCognitiveAnalysisReason, JobLogEventType, JobLogStatus, PublicationCognitiveAnalysisReason } from 'models/ApiEnums';
import { JobLogDto, JobLogEventTypeDto, JobLogFilter, JobLogFilterPeriod, PagedResult } from 'models/ApiModels';
import moment from 'moment';
import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { RouteComponentProps, withRouter } from 'react-router-dom';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

type AdditionalInfoProps = { data: JSON; };

const RenderExceptions: React.FC<{ exceptions: string[]; }> = ({ exceptions }) => {
    if (exceptions == null || exceptions.length == 0) return null;
    return (
        <ul>
            {exceptions.map((v) => <li><MuiColor variant="error">{v}</MuiColor></li>)}
        </ul>
    );
};

const Render1030: React.FC<AdditionalInfoProps> = ({ data }) => {
    return <div>
        <table>
            <tr>
                <td>Publicações Indexadas:</td>
                <td>{data["TotalOfInserts"]}</td>
            </tr>
            <tr>
                <td>Publicações Removidas:</td>
                <td>{data["TotalOfDeletes"]}</td>
            </tr>
            <tr>
                <td>Estatísticas Atualizadas:</td>
                <td>{data["TotalOfUpdateStatistics"]}</td>
            </tr>
        </table>
    </div>;
};

const Render1040: React.FC<AdditionalInfoProps> = ({ data }) => {
    return <div>
        <table>
            <tr>
                <td>Sucesso:</td>
                <td>{data["TotalSuccess"]}</td>
            </tr>
            <tr>
                <td>Erros:</td>
                <td>{data["TotalErrors"]}</td>
            </tr>
        </table>
    </div>;
};

const Render1051: React.FC<AdditionalInfoProps> = ({ data }) => {
    const imagesCognitivePassed = data["ImagesCognitivePassed"] as boolean;
    const title = data["Title"] as string;
    const cognitiveAnalysisReasons = data["CognitiveAnalysisReasons"] as PublicationCognitiveAnalysisReason;
    const approvalStatus = data["ApprovalStatus"] as ApprovalStatus;
    return <div>
        {
            title != null &&
            <div>
                <b>{title}</b>
            </div>
        }

        {
            imagesCognitivePassed != null &&
            <div>
                <span>Resultado na análise cognitiva nas imagens: </span>
                {imagesCognitivePassed === true ? "passou" : "não passou"}
            </div>
        }

        {
            cognitiveAnalysisReasons != null &&
            <div>
                <span>Resultado da Análise: </span>
                {
                    cognitiveAnalysisReasons == PublicationCognitiveAnalysisReason.None
                        ? <MuiColor variant="success"><b>passou</b></MuiColor>
                        : (
                            <ul style={{ margin: 0 }}>
                                {
                                    Object.keys(PublicationCognitiveAnalysisReason).map((v) => {
                                        return ((cognitiveAnalysisReasons & PublicationCognitiveAnalysisReason[v]) > 0)
                                            ? <li><MuiColor variant="error"><PublicationCognitiveAnalysisReasonName value={PublicationCognitiveAnalysisReason[v]} /></MuiColor></li>
                                            : null;
                                    })
                                }
                            </ul>
                        )
                }
            </div>
        }

        {
            approvalStatus != null &&
            <div>
                <span>Status de Aprovação</span>: <b><ApprovalStatusName approvalStatus={approvalStatus} /></b>
            </div>
        }
    </div>;
};

const Render1052: React.FC<AdditionalInfoProps> = ({ data }) => {
    return <div>
        <div>Total de Publicações: {data["TotalPublications"]}</div>
    </div>;
};

const Render1055: React.FC<AdditionalInfoProps> = ({ data }) => {
    return <div>
        <div>Total de Publicações: {data["TotalPublications"]}</div>
    </div>;
};

const Render1056: React.FC<AdditionalInfoProps> = ({ data }) => {
    return <div>
        <div>Total de Notificações: {data["TotalNotified"]}</div>
    </div>;
};

const Render1057: React.FC<AdditionalInfoProps> = ({ data }) => {
    if (data != null && data["FewData"] === true) return <div>Não há publicações suficientes para criar uma classificação</div>;
    return null;
};

const Render1060: React.FC<AdditionalInfoProps> = ({ data }) => {
    return <div>
        <table>
            <tr>
                <td>Perguntas Processadas:</td>
                <td>{data["QuestionsProcessed"]}</td>
            </tr>
            <tr>
                <td>Total de Usuários Encontrados:</td>
                <td>{data["TotalUsersFound"]}</td>
            </tr>
        </table>
    </div>;
};

const Render1061: React.FC<AdditionalInfoProps> = ({ data }) => {
    return <div>
        <table>
            <tr>
                <td>Total Adicionado:</td>
                <td>{data["TotalOfInserts"]}</td>
            </tr>
            <tr>
                <td>Total Removido:</td>
                <td>{data["TotalOfDeletes"]}</td>
            </tr>
        </table>
    </div>;
};

const Render1071: React.FC<AdditionalInfoProps> = ({ data }) => {
    return <div>
        <table>
            <tr>
                <td>Matrículas Fechadas:</td>
                <td>{data["TotalClosed"]}</td>
            </tr>
            <tr>
                <td>Matrículas Notificadas:</td>
                <td>{data["TotalNotified"]}</td>
            </tr>
        </table>
    </div>;
};

const Render1092: React.FC<AdditionalInfoProps> = ({ data }) => {
    const title = data["Title"] as string;
    const cognitiveAnalysisReasons = data["CognitiveAnalysisReasons"] as FileCognitiveAnalysisReason;
    const cognitiveAnalysisResult = data["CognitiveAnalysisResult"] as boolean;
    const approvalStatus = data["ApprovalStatus"] as ApprovalStatus;
    const totalDiskSpaceUsed = data["TotalDiskSpaceUsed"] as number;
    const wasDeleted = data["WasDeleted"] as boolean;

    var cognitiveReasons = cognitiveAnalysisResult == null
        ? null
        : Object.keys(FileCognitiveAnalysisReason).filter(v => ((cognitiveAnalysisReasons & FileCognitiveAnalysisReason[v]) > 0));

    return (
        <div>
            {
                title != null &&
                <div>
                    <b>{title}</b>
                </div>
            }

            {
                wasDeleted === true &&
                <div>
                    <MuiColor variant="error">Removido</MuiColor>
                </div>
            }

            {
                cognitiveAnalysisResult != null &&
                <div>
                    <span>Resultado da Análise de Vídeo: </span>
                    {
                        cognitiveAnalysisResult === true
                            ? <MuiColor variant="success"><b>passou</b></MuiColor>
                            : cognitiveReasons.length > 0
                                ? (
                                    <ul style={{ margin: 0 }}>
                                        {
                                            cognitiveReasons.map((v) => <li><MuiColor variant="error"><FileCognitiveAnalysisReasonName value={FileCognitiveAnalysisReason[v]} /></MuiColor></li>)
                                        }
                                    </ul>
                                )
                                : null

                    }
                </div>
            }
            {
                totalDiskSpaceUsed != null && totalDiskSpaceUsed > 0 &&
                <div>
                    <span>Espaço ocupado pelos arquivos: <b>{Formaters.fileSize(totalDiskSpaceUsed)}</b></span>
                </div>
            }
            {
                approvalStatus != null &&
                <div>
                    <span>Status de Aprovação: <b><ApprovalStatusName approvalStatus={approvalStatus} /></b></span>
                </div>
            }
        </div>
    );

};

const Render1095: React.FC<AdditionalInfoProps> = ({ data }) => {
    return <div>
        <table>
            <tr>
                <td>Processados com Sucesso:</td>
                <td>{data["TotalSuccess"]}</td>
            </tr>
            <tr>
                <td>Processados com Erro:</td>
                <td>{data["TotalErrors"]}</td>
            </tr>
            <tr>
                <td>Metadados não encontrado:</td>
                <td>{data["TotalNotFound"]}</td>
            </tr>
        </table>
    </div>;
};

const Render1010: React.FC<AdditionalInfoProps> = ({ data }) => {
    const totalDiskSpaceUsed = data["FreedSpace"] as number;

    return totalDiskSpaceUsed == null
        ? null
        : (
            <div>
                <span>Espaço liberado: {Formaters.fileSize(totalDiskSpaceUsed)}</span>
            </div>
        );
};

const Render1101: React.FC<AdditionalInfoProps> = ({ data }) => {
    return <div>
        <div>Total de Tópicos: {data["TotalTopics"]}</div>
    </div>;
};

const AdditionalInfoTable: Record<number, React.FC<AdditionalInfoProps>> = {
    1030: Render1030,
    1040: Render1040,
    1051: Render1051,
    1052: Render1052,
    1055: Render1055,
    1056: Render1056,
    1057: Render1057,
    1060: Render1060,
    1061: Render1061,
    1071: Render1071,
    1092: Render1092,
    1095: Render1095,
    1010: Render1010,
    1101: Render1101
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    eventTypeMenuAnchorEl: any;
    statusMenuAnchorEl: any;
    periodMenuAnchorEl: any;

    dialog: any;
    list: PagedResult<JobLogDto>;
    offset: number;
    loading: boolean;
    lastError: any;
}

interface IProps {
    jobLogEventType: JobLogEventType;
}

interface IRouteProps {
    id: string;
}

type Props = IProps & RouteComponentProps<IRouteProps> & WithSnackbar & WithTranslation & WithStyles<typeof TextColorStyleClasses>;

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class JobLogListComponent extends React.Component<Props, IState> {
    private filter: JobLogFilter;
    private eventTypes: JobLogEventTypeDto[] = [];

    constructor(props: Props) {
        super(props);
        this.state = {
            list: { items: null, total: 0 },
            offset: 0,
            loading: false,
            lastError: null,
            dialog: null,
            eventTypeMenuAnchorEl: null,
            periodMenuAnchorEl: null,
            statusMenuAnchorEl: null
        };

        this.resetFilter();
    }

    ///
    private resetFilter = () => {
        this.filter = {
            eventType: this.props.jobLogEventType,
            eventId: null,
            period: JobLogFilterPeriod.All,
            status: JobLogStatus.Unset
        };
    };

    ///
    private resetAndReload = () => {
        this.resetFilter();
        this.loadData(this.state.offset);
    };
    ///
    private res(r: string) {
        return this.props.t("Views.System.Components.JobLogList." + r);
    }

    private initData() {
        api.getJobLogEventTypes(this.props.jobLogEventType)
            .then((result) => {
                this.eventTypes = result;
                this.loadData(0);
            })
            .catch((error) => {
                this.setState({ list: null, lastError: error, loading: false, offset: 0 });
            });
    }

    private loadData(offset: number) {

        this.setState({ loading: true, dialog: null });

        api.getJobLogEvents({ filter: this.filter, range: { offset, take: DefaultListParameters.viewRecordsByPage } })
            .then((result) => {
                this.setState({ list: result, loading: false, offset: offset });
            })
            .catch((error) => {
                this.setState({ list: null, lastError: error, loading: false, offset: 0 });
            });
    }

    ///
    private isFiltered() {
        return this.filter.status != JobLogStatus.Unset || this.filter.period != JobLogFilterPeriod.All || this.filter.eventId != null;
    }

    ///
    private get periodOptions() {
        return [
            { text: this.props.t("Common.Filter.Toolbar.Period.Any"), value: JobLogFilterPeriod.All },
            { text: this.props.t("Common.Filter.Toolbar.Period.Today"), value: JobLogFilterPeriod.Today },
            { text: this.props.t("Common.Filter.Toolbar.Period.LastWeek"), value: JobLogFilterPeriod.LastWeek },
            { text: this.props.t("Common.Filter.Toolbar.Period.LastTwoWeeks"), value: JobLogFilterPeriod.LastTwoWeeks },
        ];
    }

    ///
    private get statusOptions() {
        return [
            { text: <JobLogStatusName status={JobLogStatus.Unset} />, value: JobLogStatus.Unset },
            { text: <JobLogStatusName status={JobLogStatus.Running} />, value: JobLogStatus.Running },
            { text: <JobLogStatusName status={JobLogStatus.Enqueued} />, value: JobLogStatus.Enqueued },
            { text: <JobLogStatusName status={JobLogStatus.FinishedSuccessfully} />, value: JobLogStatus.FinishedSuccessfully },
            { text: <JobLogStatusName status={JobLogStatus.FinishedWithError} />, value: JobLogStatus.FinishedWithError },
            { text: <JobLogStatusName status={JobLogStatus.Canceled} />, value: JobLogStatus.Canceled }
        ];
    }

    ///
    private applyJobEventId = (eventId: number) => {
        this.filter.eventId = eventId;
        this.setState({ eventTypeMenuAnchorEl: null });
        this.loadData(0);
    };

    ///
    private applyStatus = (status: JobLogStatus) => {
        this.filter.status = status;
        this.setState({ statusMenuAnchorEl: null });
        this.loadData(0);
    };

    ///
    private applyPeriod = (period: JobLogFilterPeriod) => {
        this.filter.period = period;
        this.setState({ periodMenuAnchorEl: null });
        this.loadData(0);
    };

    ///
    private renderAdvFilter(): JSX.Element {
        return (
            <AppBar color="secondary" position="static">
                <MuiFilterToolbar variant="dense" >
                    <MuiFilterLine>

                        <ButtonDropdown
                            text={this.filter.eventId == null ? this.props.t("Common.Filter.Toolbar.JobEvent.Any") : this.eventTypes.find(p => p.eventId == this.filter.eventId).eventName}
                            onClick={
                                (e) => { this.setState({ eventTypeMenuAnchorEl: e.currentTarget }); }
                            }
                        />
                        <Menu
                            anchorEl={this.state.eventTypeMenuAnchorEl}
                            open={this.state.eventTypeMenuAnchorEl != null}
                            onClose={() => { this.setState({ eventTypeMenuAnchorEl: null }); }}
                        >
                            {
                                this.eventTypes.map((v, index) =>
                                    <MuiMenuItemChecked key={index} text={v.eventName} value={v.eventId} currentSelection={this.filter.eventId} onClick={this.applyJobEventId} />
                                )
                            }
                        </Menu>


                        <ButtonDropdown
                            text={this.statusOptions.find(p => p.value == this.filter.status).text}
                            onClick={(e) => { this.setState({ statusMenuAnchorEl: e.currentTarget }); }
                            }
                        />
                        <Menu
                            anchorEl={this.state.statusMenuAnchorEl}
                            open={this.state.statusMenuAnchorEl != null}
                            onClose={() => { this.setState({ statusMenuAnchorEl: null }); }}
                        >
                            {
                                this.statusOptions.map((v, index) =>
                                    <MuiMenuItemChecked key={index} text={v.text} value={v.value} currentSelection={this.filter.status} onClick={this.applyStatus} />
                                )
                            }
                        </Menu>


                        <ButtonDropdown
                            text={this.periodOptions.find(p => p.value == this.filter.period).text}
                            onClick={(e) => { this.setState({ periodMenuAnchorEl: e.currentTarget }); }
                            }
                        />
                        <Menu
                            anchorEl={this.state.periodMenuAnchorEl}
                            open={this.state.periodMenuAnchorEl != null}
                            onClose={() => { this.setState({ periodMenuAnchorEl: null }); }}
                        >
                            {
                                this.periodOptions.map((v, index) =>
                                    <MuiMenuItemChecked key={index} text={v.text} value={v.value} currentSelection={this.filter.period} onClick={this.applyPeriod} />
                                )
                            }
                        </Menu>


                    </MuiFilterLine>
                </MuiFilterToolbar>
            </AppBar>
        );
    }

    //
    private renderAdditionalInfo(item: JobLogDto) {
        if (item.additionalInfo == null) return null;

        const exceptions = item.additionalInfo["Exceptions"] as string[];
        const RenderInfo: React.FC<AdditionalInfoProps> = AdditionalInfoTable[item.eventId];
        return (
            <>
                {RenderInfo && <small><RenderInfo data={item.additionalInfo} /></small>}
                {exceptions && <div><small><RenderExceptions exceptions={exceptions} /></small></div>}
            </>
        );
    }

    //
    private renderItems() {
        const { list } = this.state;

        return (
            <div>
                <MuiContainer margin="dense" >
                    <div className={GlobalClassKeys.textRight}>
                        <RefreshLink onClick={() => this.loadData(0)} />
                    </div>
                </MuiContainer>
                <MuiPaper>
                    <MuiContainer margin="dense" >
                        <TableContainer >
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{this.res("EventDateLabel")}</TableCell>
                                        <TableCell>{this.res("EventLabel")}</TableCell>
                                        <TableCell>{this.res("StatusLabel")}</TableCell>
                                        <TableCell>{this.res("AdditionalInfoLabel")}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        list.items.map((item, index) => {
                                            const statusColor: MuiColors = item.status == JobLogStatus.FinishedWithError
                                                ? "error"
                                                : item.status == JobLogStatus.FinishedSuccessfully
                                                    ? "success"
                                                    : item.status == JobLogStatus.Enqueued
                                                        ? "info"
                                                        : item.status == JobLogStatus.Running
                                                            ? "warning"
                                                            : "inherit";

                                            const spentTime = item.finishedAt == null
                                                ? null
                                                : moment.utc(moment(item.finishedAt).diff(item.startedAt)).format("HH:mm:ss");

                                            return (
                                                <TableRow key={index} className={GlobalClassKeys.cellAlignTop}>
                                                    <TableCell>
                                                        {Formaters.localeDate(item.startedAt)}
                                                        <br />
                                                        {Formaters.localeTime(item.startedAt)}</TableCell>
                                                    <TableCell >
                                                        {item.eventName}
                                                    </TableCell>
                                                    <TableCell>
                                                        <MuiColor variant={statusColor}>
                                                            <JobLogStatusName status={item.status} />
                                                        </MuiColor>
                                                        {
                                                            spentTime &&
                                                            <div>
                                                                <MuiColor variant="muted">
                                                                    <span>({spentTime})</span>
                                                                </MuiColor>
                                                            </div>
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {this.renderAdditionalInfo(item)}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </MuiContainer>
                    <MuiPagination
                        limit={DefaultListParameters.viewRecordsByPage}
                        offset={this.state.offset}
                        total={this.state.list.total}
                        onClick={(e, offset) => this.loadData(offset)}
                    />
                </MuiPaper >
            </div>
        );
    }

    ///
    public componentDidMount() {
        this.initData();
    }

    ///
    public render() {

        const { dialog, list, lastError, loading } = this.state;

        return (
            <div>
                {dialog}

                {
                    (!lastError && (loading || list.total > 0 || this.isFiltered())) &&
                    <MuiContainer margin="normal">
                        {this.renderAdvFilter()}
                    </MuiContainer>
                }

                {
                    lastError
                        ? <RequestErrorReport error={lastError} />
                        : loading
                            ? <LoadingIndicator />
                            : list.total == 0 && !this.isFiltered()
                                ? <MuiMessageBox variant="info" message={this.res("RsResultText_zero")} />
                                : list.total == 0 && this.isFiltered()
                                    ? (
                                        <MuiMessageBox
                                            variant="warning"
                                            action={<ButtonResetFilter color="warning" onClick={this.resetAndReload} />}
                                            message={this.res("RsFilteredResultText_zero")}
                                        />
                                    )
                                    : this.renderItems()
                }

            </div>
        );
    }
}

const JobLogList = withRouter(withSnackbar(withTranslation()(withStyles(TextColorStyleClasses)(JobLogListComponent))));

export const JobLogIAList: React.FC<{}> = () => <JobLogList jobLogEventType={JobLogEventType.IA} />;
export const JobLogOthersList: React.FC<{}> = () => <JobLogList jobLogEventType={JobLogEventType.Others} />;;